import { Component, Input, ViewEncapsulation } from '@angular/core';
import { LanguageService } from '@signature-it/ngx-generic/services';
import { DropdownLangsComponentGeneric } from "../dropdown/dropdown-langs";

@Component({
    selector: 'lang-selector',
    templateUrl: './lang-selector.component.html',
    styleUrls: ['./lang-selector.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class LangSelectorComponent extends DropdownLangsComponentGeneric{

    @Input() flatMode = false;
    @Input() dropdownBtnClass: '';
    @Input() showFlagIcon: boolean = false;
    constructor(public langSvc: LanguageService) {
        super(langSvc);
    }

}
